export const information = {
  site: "f168",
  cskh_url: "https://f16811.online/codecskh",
  cskh_home: "https://f1681.bar/trangchu",
  endpoint: "https://api-freecode-f168.freecodevip.org",
  follow_code: "https://t.me/f168freecode",
  follow_tele: "https://f1681.email/social/telegram",
  follow_fb: "https://f16811.online/codefb",
  follow_insta: "https://f1681.email/social/insta",

  follow_detail_code: "https://f16811.online/code",
  key_free: "f168apt.code.free-code.f168@2030$F168ff",
};
